const MAIN_PAGE_META = {
  title: 'Easi Rewards | Rewards Chart for Kids',
  meta: [
    {
      name: 'description',
      content: `Get the real motivational reward system for your kids! Use Easi Rewards to assign quests to your kids. They’ll see their tasks, deadlines, & points to earn.`
    },
    {
      property: 'og:title',
      content: `Easi Rewards | Rewards Chart for Kids`
    },
    { property: 'og:site_name', content: 'Easi Rewards' },
    { property: 'og:type', content: 'website' },
    {
      property: 'og:url',
      content: 'https://www.facebook.com/easirewardsclub/'
    },
    {
      property: 'og:description',
      content: `Get the real motivational reward system for your kids! Use Easi Rewards to assign quests to your kids. They’ll see their tasks, deadlines, & points to earn.`
    },
    { name: 'robots', content: 'index,follow' },
    { name: 'og:country-name', content: 'CA' },
    { name: 'og:image', content: '' }
  ],
  link: [{ rel: 'canonical', href: 'https://www.easirewards.club/' }]
};

const ABOUT_META = {
  title:
    'About | Online Behaviour Chart | Rewards Chart for Kids | Easi Rewards',
  meta: [
    {
      name: 'description',
      content: `At Easi Rewards, our aim is to create a kids reward platform for parents to use with their kids that helps motivate them to engage in positive behaviours.`
    }
  ]
};

const FAQ_META = {
  title: `FAQ |Online Behavior Chart | Rewards Chart for Kids | Easi Rewards`,
  meta: [
    {
      name: 'description',
      content: `Here you can find the frequently asked questions related to rewards chart for kids, online behavior chart, chore rewards, payment methods, and more.`
    }
  ]
};

const BLOG_META = {
  title: `Blog | Motivating a child with ADHD/LD's | Rewards System for Kids`,
  meta: [
    {
      name: 'description',
      content: `Discover everything you need to know about setting up a rewards system for kids. Here you can find how to motivating a child with ADHD/LD's.`
    }
  ]
};

export { MAIN_PAGE_META, ABOUT_META, FAQ_META, BLOG_META };



// WEBPACK FOOTER //
// ./src/consts/metaTags.js